import { HttpErrorResponse } from '@angular/common/http';

export function isDuplicateNameError(err: unknown): boolean {
  if (!(err instanceof HttpErrorResponse) || err.status !== 422) {
    return false;
  }

  const message: string =
    err.error?.statusMessage ?? err.error?.statusDetails ?? '';

  return message.includes('/stories');
}
